<script>
    import { classNames } from "../../utils";
    // your script goes here
    let cls = "sui-divider";
    // 'center' | 'left' | 'right'
    export let contentPosition = "center";
    //'horizontal' | 'vertical'
    export let direction = "horizontal";
</script>

<div
    class={classNames({
        [cls]: cls,
        [contentPosition]: contentPosition,
        [direction]: direction,
    })}
>
    <span class={`${cls}-content`}><slot /></span>
</div>

<style lang="less">
    @import './divider.less';
</style>
